module.exports = __webpack_public_path__ + "static/media/uptin-white.c91b2c92.svg";